import { Component, ojs, app, state, v, payload } from "modular-openscriptjs";
import {
  pageInfo,
  inform,
  consoleErrorOnLocal,
  cleanDispose,
  eParse,
  scrollToTop,
} from "../../../helpers";
import { api } from "../../../declarations";
import SolidIcon from "../../Blocks/SolidIcon";
import { dom, tool } from "../../../fotastart";
import { $e } from "../../../ojs.events";
import Spinner from "../../Blocks/Spinner";

const h = app("h");
const router = app("router");
const broker = app("broker");

ojs(SolidIcon, Spinner);

export default class ManageLegalInfo extends Component {
  businessId = null;
  business = state(null);
  loading = state(true);

  formData = {
    legal_id_number: "",
    terms_link: "",
  };

  $$company = {
    updated: () => {
      const btn = dom.id(`update-legal-btn-${this.id}`);
      if (btn) {
        dom.enable(btn);
        h.span("Save Changes", { parent: btn, resetParent: true });
      }
    },
    has: {
      updateError: () => {
        const btn = dom.id(`update-legal-btn-${this.id}`);
        if (btn) {
          dom.enable(btn);
          h.span("Save Changes", { parent: btn, resetParent: true });
        }
      },
    },
  };

  render() {
    this.businessId = router.params.companyId;
    scrollToTop();

    if (this.loading.value) {
      this.fetchBusiness();
    }

    return h.div(
      { class: "min-vh-100 py-5 mb-5 py-md-5" },
      h.div(
        { class: "container" },
        h.div(
          { class: "mb-5 d-flex align-items-center gap-3" },
          h.button(
            {
              class: "btn btn-white border shadow-sm rounded-circle p-2",
              listeners: {
                click: () => history.back(),
              },
            },
            h.SolidIcon("arrow-left"),
          ),
          h.h2({ class: "fw-bold mb-0" }, "Legal Information"),
        ),

        v(this.loading, (l) => {
          if (l.value) return h.div({ class: "text-center py-5" }, h.Spinner());

          return h.div(
            {
              class: "card border-1 shadow-sm mx-auto",
              style: "max-width: 800px; border-radius: 20px;",
            },
            h.div(
              { class: "card-body p-4 p-md-5" },
              h.h4({ class: "fw-bold mb-4" }, "Business Legal Details"),
              h.p(
                { class: "text-muted small mb-5" },
                "Provide your official business registration details and links to your customer agreements.",
              ),

              h.div(
                { class: "row g-4" },
                h.div(
                  { class: "col-12" },
                  h.label(
                    {
                      class: "form-label fw-600 small text-uppercase text-muted",
                    },
                    "Business Registration Number",
                  ),
                  h.input({
                    class: "form-control bg-light border p-3",
                    value: this.formData.legal_id_number,
                    placeholder: "e.g. PVT-ABC12345",
                    listeners: {
                      input: (e) =>
                        (this.formData.legal_id_number = e.target.value),
                    },
                  }),
                  h.small(
                    { class: "text-muted" },
                    "Enter your official government-issued business registration number or certificate of incorporation ID.",
                  ),
                ),
                h.div(
                  { class: "col-12" },
                  h.label(
                    {
                      class: "form-label fw-600 small text-uppercase text-muted",
                    },
                    "Terms & Conditions Link",
                  ),
                  h.input({
                    class: "form-control bg-light border p-3",
                    type: "url",
                    value: this.formData.terms_link,
                    placeholder: "e.g. https://yourbusiness.com/terms",
                    listeners: {
                      input: (e) => (this.formData.terms_link = e.target.value),
                    },
                  }),
                  h.small(
                    { class: "text-muted" },
                    "Paste the full web address (URL) where your customers can find your business rules and policies.",
                  ),
                ),
                h.div(
                  { class: "col-12 mt-5" },
                  h.button(
                    {
                      class:
                        "btn btn-primary rounded-pill px-5 py-3 fw-bold shadow-sm",
                      id: `update-legal-btn-${this.id}`,
                      listeners: {
                        click: (e) => this.updateLegalInfo(e.target),
                      },
                    },
                    "Save Changes",
                  ),
                ),
              ),
            ),
          );
        }),
      ),
    );
  }

  async fetchBusiness() {
    try {
      const res = await api.get(`companies/${this.businessId}`);
      if (res) {
        this.business.value = res.data.company;
        this.formData.legal_id_number =
          res.data.company.legal_id_number || "";
        this.formData.terms_link = res.data.company.terms_link || "";
      }
    } catch (e) {
      consoleErrorOnLocal(e);
    } finally {
      this.loading.value = false;
    }
  }

  updateLegalInfo(btn) {
    dom.disable(btn);
    h.Spinner({ parent: btn, resetParent: true });

    broker.send(
      $e.company.needs.update,
      payload({
        id: this.businessId,
        ...this.formData,
      }),
    );
  }
}

ojs(ManageLegalInfo);
